import Vue from 'vue';
import moment from 'moment-timezone';
import store from "@/store/index";
import i18n from '@/libs/i18n';

Vue.filter('formatDate', function (value, format = 'LLL') {
  if (!value) {
    return "";
  }

  if (store.state.profile.origin) {
    return moment(value).locale(i18n.locale).tz(store.state.profile.origin).format(format);
  }

  return moment(value).locale(i18n.locale).format(format);
});

Vue.filter('formatDateEmpty', function (value, format = 'LLL') {
  if (!value) {
    return "-";
  }

  if (store.state.profile.origin) {
    return moment(value).locale(i18n.locale).tz(store.state.profile.origin).format(format);
  }

  return moment(value).locale(i18n.locale).format(format);
});


Vue.filter('formatShortDate', function (value, format) {
  if (!value) {
    return "";
  }

  if (store.state.profile.origin) {
    return moment(value, format).locale(i18n.locale).tz(store.state.profile.origin).calendar(null, {
      sameDay: "h:mm A",
      lastDay: "ddd h:mm A",
      lastWeek: "ddd h:mm A",
      sameYear: "lll",
      sameElse: "lll",
    });
  }

  return moment(value, format).locale(i18n.locale).calendar(null, {
    sameDay: "h:mm A",
    lastDay: "dddd h:mm A",
    lastWeek: "dddd h:mm A",
    sameYear: "lll",
    sameElse: "lll",
  });
});
